import { render, staticRenderFns } from "./ElImageV4.vue?vue&type=template&id=c9eff6e0"
import script from "./ElImageV4.vue?vue&type=script&lang=js"
export * from "./ElImageV4.vue?vue&type=script&lang=js"
import style0 from "./ElImageV4.vue?vue&type=style&index=0&id=c9eff6e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports